import { Box, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';

interface OrderDetailsDrawerHeaderProps {
}

const OrderDetailsDrawerHeader: React.FC<OrderDetailsDrawerHeaderProps> = observer(({ }) => {
    return (
        <Box>
            <Typography fontWeight={600}>Detalji narudžbe</Typography>
        </Box>
    )
})

export default OrderDetailsDrawerHeader;